import { PeriodFilter } from 'types/GlobalWidget'

// every 5th minute
export const STATUS_BANNER_TIMER = 60000 * 5

// lowest accepted ?refresh interval on public pages, in seconds
export const MIN_AUTO_REFRESH_SECONDS = 600

// how often ?refresh_at compares the wall clock against its next target
export const CLOCK_REFRESH_CHECK_INTERVAL_MS = 30000

// tooltip text for when details is disabled for kpi
export const DETAILS_DISABLE_TEXT =
  'Det går inte att visa innehåll för det här mätetalet'

export const FINANCIAL_YEAR_PERIOD_FILTERS = [
  PeriodFilter.CURRENT_FINANCIAL_YEAR,
  PeriodFilter.PREVIOUS_FINANCIAL_YEAR,
  PeriodFilter.LAST_3_FINANCIAL_YEARS_TO_TODAY
]
